import React, { useState, useEffect } from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import charleyslogo from '../../assets/charleyslogo.png';
import { FaWhatsapp } from "react-icons/fa";


function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image : "/Charleyspics/appetizers/curly fries.jpg",
      caption: 'Curly Fries',
    },
    {
      image : "/Charleyspics/pizza/pizza supreme.jpg",
      caption: 'Supreme Pizza',
    },
    {
      image: "/Charleyspics/saj/saj tawouk.jpg",
      caption: 'Saj Taouk',
    },

     {
      image: "/Charleyspics/burgers/burger classic.jpg",
      caption: 'Classic Burger',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Slide changes every 5 seconds
    return () => clearInterval(interval);
  }, [slides.length]);

  
  return (
    <div className="home__bg" >
      <main className="home__content">
        <img 
          src={charleyslogo} 
          alt="Charley's Logo" 
          className="charleys-logo" 
        />

    <div className="button-row">
      <Link to="/menu" className="custom__button">
        Explore Our Menu
      </Link>
      <a
    href="https://wa.me/message/I4STMZVCMEQ6F1"
    className="whatsapp-button"
    target="_blank"
    rel="noopener noreferrer"
>
  <FaWhatsapp className="whatsapp-icon" />
  Whatsapp
</a>

    </div>


        
       
        <div className="home__carousel">
          <div
            className="carousel__track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div className="carousel__slide" key={index}>
                <img src={slide.image} alt={slide.caption} />
                <p className="p__opensans">{slide.caption}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <footer className="home__footer">
        <p className="p__opensans">© 2025 Charley's. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;